module.exports = __webpack_public_path__ + "img/bgc.77dd71ec.png";